export interface StmacPostMessage {
    readonly type: string;
    //* Optional. If provided, an error / success confirmation message will be
    //* emitted when the operation completes.*/
    readonly tid?: any;

    readonly qct?: string; //* only in catalog
}


//* CATALOG PRODUIT

export class StmacMessages {

    public static isPostMessageProductSelected = (type: string) => type === "product_selected:pol";

}
